import { render, staticRenderFns } from "./spusaleChart.vue?vue&type=template&id=1961f8bb&scoped=true&"
import script from "./spusaleChart.vue?vue&type=script&lang=js&"
export * from "./spusaleChart.vue?vue&type=script&lang=js&"
import style0 from "./spusaleChart.vue?vue&type=style&index=0&id=1961f8bb&prod&lang=scss&scoped=true&"
import style1 from "./spusaleChart.vue?vue&type=style&index=1&id=1961f8bb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1961f8bb",
  null
  
)

export default component.exports